var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "Legal-info" }, [
    _c("div", { staticClass: "Legal-content" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "Collection-main" },
        [
          _c(
            "el-form",
            { staticClass: "Form-style" },
            [
              _c(
                "el-form-item",
                { staticClass: "Company-name", attrs: { label: "姓名" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入准确的法人姓名" },
                    model: {
                      value: _vm.dataForm.legalPerson,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "legalPerson", $$v)
                      },
                      expression: "dataForm.legalPerson",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "Company-name",
                  attrs: { label: "身份证件类型" },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择法人身份证件类型" },
                      model: {
                        value: _vm.dataForm.certificatesLegal,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "certificatesLegal", $$v)
                        },
                        expression: "dataForm.certificatesLegal",
                      },
                    },
                    _vm._l(_vm.certificatesLegalOption, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "Company-name",
                  attrs: { label: "身份证件号码" },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "点击输入法人身份证件号码" },
                    model: {
                      value: _vm.dataForm.certificatesLegalNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "certificatesLegalNumber", $$v)
                      },
                      expression: "dataForm.certificatesLegalNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "Company-name", attrs: { label: "法人手机号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "点击输入法人手机号码" },
                    model: {
                      value: _vm.dataForm.legalPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.dataForm, "legalPhone", $$v)
                      },
                      expression: "dataForm.legalPhone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "Company-name Last-hang",
                  attrs: { label: "身份证件" },
                },
                [
                  _c("wintac-upload", {
                    staticClass: "Front",
                    attrs: {
                      imgName: "法人证件正面",
                      pid: _vm.dataForm.id,
                      state: 2,
                      env: "user",
                    },
                  }),
                  _c("wintac-upload", {
                    staticClass: "Front",
                    attrs: {
                      pid: _vm.dataForm.id,
                      imgName: "法人证件反面",
                      state: 3,
                      env: "user",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "Legal-top" }, [
      _c("h1", [_vm._v("法人信息")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }